import { gql } from 'graphql-request';

import withFragments from 'utils/graphql';

import { QuickNavigation } from 'fragments/QuickNavigation';
import Hero from 'fragments/Hero';
import Facilities from 'fragments/Facility';
import FAQBlock from 'fragments/Faq';
import PopularActivities from 'fragments/PopularActivity';
import CTABlock from 'fragments/CTABlock';
import LatestNews from 'fragments/LatestNews';
import Contact from 'fragments/Contact';
import { RichTextBlock, CustomEmbedBlock } from 'fragments/GenericBlocks';
import Logo from 'fragments/Logo';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!, $hostname: String) {
      page(id: $id, contentType: $contentType, token: $token) {
        id
        url
        title
        slug
        seoTitle
        seoDescription
        ... on HomePage {
          recaptchaKey
          metaImage {
            url
          }
          metaTitle
          metaDescription
          logo {
            ...Logo
          }
          newsletterTitle
          newsletterBody
          activityChooserTitle
          activityChooserSubtitle
          activityChooserThemes {
            name
            shortDescription
            icon
            id
          }
          activityChooserIndex {
            url
          }
          body {
            id
            blockType
            ...QuickNavigation
            ...Facilities
            ...Faq
            ...PopularActivities
            ...CTABlock
            ...LatestNews
            ...Contact
            ...RichTextBlock
            ...CustomEmbedBlock
          }
          carousel {
            id
            field
            ... on ImageChooserBlock {
              image {
                title
                xl: rendition(fill: "1920x800-c100") {
                  url
                }
                md: rendition(fill: "1280x830-c100") {
                  url
                }
                sm: rendition(fill: "768x500-c100") {
                  url
                }
                xs: rendition(fill: "640x300-c100") {
                  url
                }
              }
            }
            ... on MediaChooserBlock {
              url
              duration
            }
          }
        }
      }
      wizardQuestions: questions {
        id
        theme {
          id
          name
        }
        content
        filterSet {
          slug
          id
          filters {
            id
            name
            slug
          }
        }
      }
      wizardAssistant: assistant(hostname: $hostname) {
        id
        name
        helpText
        avatar: image {
          sm: rendition(fill: "60x60") {
            url
          }
          lg: rendition(fill: "110x110") {
            url
          }
        }
      }
    }
  `,
  {
    QuickNavigation,
    Facilities,
    FAQBlock,
    Hero,
    PopularActivities,
    CTABlock,
    LatestNews,
    Contact,
    RichTextBlock,
    CustomEmbedBlock,
    Logo,
  },
);
